module.exports = __webpack_public_path__ + "img/linux.e4ba9a3d.png";